<template>
  <RootPageLayout title="Settings">
    <section class="settings-section">
      <div class="container">
        <template v-if="settingsView.isLoading">
          <loading-spinner />
        </template>
        <template v-if="settingsView.isError">
          <LoadingError />
        </template>
        <div v-if="settingsView.isLoaded" class="settings">
          <ul class="sidebar">
            <li class="sidebar__item">
              <div class="active-bar" />
              Account
              <span class="spacer" />
              <span class="iconfont iarrow active-arrow" />
            </li>
          </ul>
          <div class="content">
            <h3>Device Notifications</h3>
            <p>Control notifications on devices where you use Shortform</p>
            <ul class="content__buttons">
              <li class="content__buttons__row">
                <ToggleButton
                  class="toggle-button"
                  :value="
                    settingsView.notificationSettings?.notify_new_release ||
                    false
                  "
                  @update:value="updateNotifyNewRelease"
                >
                  New summary announcements
                </ToggleButton>
              </li>
            </ul>
            <h3 class="settings-email">Account Email</h3>
            <p>{{ email }}</p>
            <InfoDeleteAccount />
          </div>
        </div>
      </div>
    </section>
  </RootPageLayout>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import RootPageLayout from '@/app/components/RootPageLayout.vue'
import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import ToggleButton from '@/components/ui/ToggleButton.vue'
import { SettingsView } from '@/models/settings'
import { getEmail } from '@/services/auth'
import InfoDeleteAccount from '@/app/components/settings/InfoDeleteAccount.vue'

const settingsView = ref(new SettingsView())
const email = ref<string | null>(null)

async function updateNotifyNewRelease(value: boolean): Promise<void> {
  await settingsView.value.toggleNotificationSetting(
    'notify_new_release',
    value,
  )
}

onBeforeMount(async () => {
  await settingsView.value.init()
  email.value = getEmail()
})
</script>

<style scoped>
.settings-section {
  margin-top: 40px;
}

.settings-email {
  margin-top: 24px;
}

.settings {
  display: flex;
  flex-flow: row nowrap;
}

.sidebar {
  display: none;
}

@media screen and (min-width: 900px) {
  .sidebar {
    display: block;
    padding: 0px;
    flex-grow: 1;
  }
}

.sidebar__item {
  max-width: 200px;

  display: flex;
  flex-flow: row-nowrap;

  line-height: 40px;
}

.active-bar {
  box-sizing: border-box;
  height: 40px;
  width: 4px;

  margin-right: 12px;

  background-color: #ffc906;
}

.spacer {
  flex-grow: 1;
}

.active-arrow {
  padding-top: 2px;
}

.content {
  flex-grow: 2;
}

.content__buttons {
  padding: 0px;
}
</style>
